import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApiService } from '../../services/api.service';

@Component({
    selector: 'app-lead-dashboard',
    imports: [CommonModule],
    templateUrl: './lead-dashboard.component.html',
    styleUrls: ['../lead-management.shared.css']
})
export class LeadDashboardComponent implements OnInit {
  loading = false;
  stats: any = {
    total_leads: 0,
    new_leads: 0,
    today_follow_ups: 0,
    demo_scheduled: 0,
    won_leads: 0,
    lost_leads: 0,
  };

  cards = [
    { key: 'total_leads', label: 'Total Leads' },
    { key: 'new_leads', label: 'New Leads' },
    { key: 'today_follow_ups', label: 'Today Follow-ups' },
    { key: 'demo_scheduled', label: 'Demo Scheduled' },
    { key: 'won_leads', label: 'Won Leads' },
    { key: 'lost_leads', label: 'Lost Leads' },
  ];

  constructor(private apiService: ApiService, private router: Router) {}

  ngOnInit(): void {
    this.loadDashboard();
  }

  loadDashboard(): void {
    this.loading = true;
    this.apiService.getLeadDashboard().subscribe({
      next: (response: any) => {
        this.stats = response || this.stats;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  goTo(route: string): void {
    this.router.navigate([route]);
  }

  openCard(cardKey: string): void {
    const today = new Date();
    const todayValue = this.formatDate(today);

    if (cardKey === 'today_follow_ups') {
      this.router.navigate(['lead-management/follow-ups'], { queryParams: { date: todayValue } });
      return;
    }

    if (cardKey === 'demo_scheduled') {
      this.router.navigate(['lead-management/demo-schedule'], { queryParams: { status: 'SCHEDULED' } });
      return;
    }

    const statusMap: Record<string, string | null> = {
      total_leads: null,
      new_leads: 'NEW',
      won_leads: 'WON',
      lost_leads: 'LOST',
    };

    const status = statusMap[cardKey];
    this.router.navigate(['lead-management/leads'], {
      queryParams: status ? { status } : {},
    });
  }

  private formatDate(value: Date): string {
    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
